import { createSelector } from 'reselect';
import { enabledButtonsSelector } from '../../select-list-footer/selectors/enabled-buttons-selector.esm.js';
import { createDisplayLayoutTypeSelector } from '../../selectors/display-layout-type-selector.esm.js';
import { createSomeFieldsSelectedSelector } from './some-fields-selected-selector.esm.js';

function getApplyButtonEnabled(fieldsSelected, layoutType) {
  var _enabledButtonsSelect = enabledButtonsSelector({
      fieldsSelected: fieldsSelected,
      layoutType: layoutType
    }),
    apply = _enabledButtonsSelect.apply;
  return apply;
}
var createApplyButtonEnabledSelector = function createApplyButtonEnabledSelector() {
  var someFieldsSelectedSelector = createSomeFieldsSelectedSelector();
  var displayLayoutTypeSelector = createDisplayLayoutTypeSelector();
  return createSelector(someFieldsSelectedSelector, displayLayoutTypeSelector, getApplyButtonEnabled);
};

export { createApplyButtonEnabledSelector };
//# sourceMappingURL=apply-button-enabled-selector.esm.js.map
